module.exports = __webpack_public_path__ + "img/MUSA-10.2f5e7f37.jpg";